import { render } from "./imagebank.vue?vue&type=template&id=35dfc8e4&scoped=true"
import script from "./imagebank.vue?vue&type=script&lang=js"
export * from "./imagebank.vue?vue&type=script&lang=js"

import "./imagebank.vue?vue&type=style&index=0&id=35dfc8e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dfc8e4"]])

export default __exports__